<template>
  <section
    class="SeasonScheduleScreenView"
    data-theme="light"
  >
    <SeasonRunListView
      v-if="season && season.runs.length > 0"
      v-bind="{season}"
      data-testid="runList"
      :runs="season.runs"
    />
    <div
      v-else
      class="SeasonScheduleScreenView__emptyState"
      role="status"
      data-testid="scheduleEmptyState"
    >
      <Icon
        class="SeasonScheduleScreenView__emptyStateIcon"
        name="personRunning"
      />
      No runs scheduled yet
    </div>
  </section>
</template>

<script lang="ts" setup>
import Icon from "@/components/Icon.vue";
import useSeasonStore from "@/stores/useSeasonStore.ts";
import { computed } from "vue";
import SeasonRunListView from "../SeasonRunListView.vue";

const {
  seasonId,
} = defineProps<{
  seasonId: string,
}>();

const {
  getSeason,
} = useSeasonStore();

const season = computed(() => {
  return getSeason(seasonId);
});
</script>

<style lang="scss" scoped>
.SeasonScheduleScreenView {
  position: relative;

  display: grid;
  gap: 16px;
  align-content: start;
  min-height: 100%;
  padding: 16px;
}

.SeasonScheduleScreenView__emptyState {
  display: grid;
  place-content: center;
  justify-items: center;
  padding-block: 16px;

  color: var(--themeColorNeutral600);

  font-stretch: var(--fontWidthExtended);
  line-height: 1.5;
}

.SeasonScheduleScreenView__emptyStateIcon {
  --iconSize: 48px;
  margin-bottom: 16px;
  color: var(--themeColorNeutral150);
}
</style>
